import { Badge, Tooltip } from '@dixa/lib-shared-habla';

type DeliveryStatusProps = {
  code: number;
  text: string;
  isSuccess: boolean;
};

export function DeliveryStatus({
  code,
  text,
  isSuccess,
}: DeliveryStatusProps): JSX.Element {
  const getStatus = () => {
    if (!code) {
      return 'No events yet';
    }

    return `${isSuccess ? 'Success' : 'Failed'} (${code})`;
  };

  const getVariant = () => {
    if (!code) {
      return 'info';
    }

    return isSuccess ? 'success' : 'error';
  };

  return (
    <Tooltip content={text} disabled={!code}>
      <Badge size="medium" variant={getVariant()}>
        {getStatus()}
      </Badge>
    </Tooltip>
  );
}
